module.exports = __webpack_public_path__ + "img/gallery.8b7b6457.svg";